import { withoutKeys } from "./configurationPatch";

export const presentedCertificateStatus = "presentedCertificateStatus";
export const presentedCertificateFetchId = "presentedCertificateFetchId";
export const presentedCertificateRequestedAt =
  "presentedCertificateRequestedAt";
export const presentedCertificateFetchedAt = "presentedCertificateFetchedAt";
export const presentedCertificateOrigin = "presentedCertificateOrigin";
export const presentedCertificate = "presentedCertificate";
export const presentedCertificateTrusted = "presentedCertificateTrusted";
export const presentedCertificateMessage = "presentedCertificateMessage";
export const presentedCertificateChain = "presentedCertificateChain";

export const STUCK_PENDING_MS = 45_000;

export const CERTIFICATE_CHANGED_MESSAGE_PREFIX = "Certificate changed:";

const presentedCertificateKeys = [
  presentedCertificateStatus,
  presentedCertificateFetchId,
  presentedCertificateRequestedAt,
  presentedCertificateFetchedAt,
  presentedCertificateOrigin,
  presentedCertificate,
  presentedCertificateTrusted,
  presentedCertificateMessage,
  presentedCertificateChain,
] as const;

/** The stored chain holds public certificates and a fixed stop enum only. */
type PresentedCertificateChain = {
  issuers: { certificate: string; source: "presented" | "aia" }[];
  complete: boolean;
  stop?: string;
  issuerVerifiesLeaf: boolean;
};

export type PresentedCertificate = {
  status?: "pending" | "success" | "failure";
  fetchId?: string;
  requestedAt?: string;
  fetchedAt?: string;
  origin?: string;
  certificate?: string;
  trusted?: "true" | "false";
  message?: string;
  chain?: PresentedCertificateChain;
};

function oneOf<T extends string>(
  value: string | undefined,
  allowed: readonly T[]
): T | undefined {
  return allowed.find((candidate) => candidate === value);
}

export function readPresentedCertificate(
  metadata: Record<string, string>
): PresentedCertificate {
  return {
    status: oneOf(metadata[presentedCertificateStatus], [
      "pending",
      "success",
      "failure",
    ]),
    fetchId: metadata[presentedCertificateFetchId],
    requestedAt: metadata[presentedCertificateRequestedAt],
    fetchedAt: metadata[presentedCertificateFetchedAt],
    origin: metadata[presentedCertificateOrigin],
    certificate: metadata[presentedCertificate],
    trusted: oneOf(metadata[presentedCertificateTrusted], ["true", "false"]),
    message: metadata[presentedCertificateMessage],
    chain: metadata[presentedCertificateChain]
      ? JSON.parse(metadata[presentedCertificateChain])
      : undefined,
  };
}

export function withoutPresentedCertificate(
  metadata: Record<string, string>
): Record<string, string> {
  return withoutKeys(metadata, presentedCertificateKeys);
}

export function withoutPresentedCertificateTrust(
  metadata: Record<string, string>
): Record<string, string> {
  return withoutKeys(metadata, [presentedCertificateTrusted]);
}
